import { Helmet } from "react-helmet-async";

const DOMAIN = "https://2161toddlane.com";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_beach-escape-fl/artifacts/75r1b3hg_IMG_6451.jpeg";

// Master keyword bank — reused across all pages for topical authority.
// Covers every meaningful local + intent variation for the Space Coast.
const GLOBAL_KEYWORDS = [
  // Brand
  "paradise beach rental", "paradise rentals florida", "beach escape fl",
  // Indialantic
  "indialantic beach house rental", "indialantic fl rental", "indialantic monthly rental",
  "furnished rental indialantic", "beach rentals indialantic florida",
  // Melbourne Beach
  "melbourne beach house rental", "melbourne beach fl rental", "melbourne beach vacation rental",
  "melbourne beach monthly rental", "melbourne beach florida house",
  // Melbourne
  "melbourne fl furnished rental", "melbourne florida corporate housing", "melbourne fl monthly rental",
  // Satellite Beach / Indian Harbour Beach
  "satellite beach rental", "indian harbour beach rental", "satellite beach fl house rental",
  // Palm Bay / Viera / Suntree
  "palm bay furnished rental", "viera monthly rental", "suntree corporate housing",
  // Cocoa Beach / Vero
  "cocoa beach monthly rental", "vero beach monthly rental",
  // Space Coast + Brevard
  "space coast rental", "space coast monthly rental", "brevard county furnished rental",
  "brevard county monthly rental", "central florida beach rental",
  // Intent / audience
  "corporate housing melbourne fl", "traveling nurse housing melbourne fl", "travel nurse rental florida",
  "snowbird rental florida", "snowbird rental indialantic", "90 day rental florida",
  "3 month rental florida", "extended stay rental florida", "executive rental brevard county",
  "relocation housing florida", "furnished beach house florida",
  // Employer/hospital driven
  "l3harris housing", "northrop grumman housing", "health first nurse housing",
  "patrick space force base rental", "florida tech housing",
  // Pet
  "pet friendly beach rental florida", "dog friendly monthly rental indialantic",
];

export const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  keywords = [],
  jsonLd = null,
  breadcrumbs = null,
  noindex = false,
}) => {
  const url = `${DOMAIN}${path === "/" ? "" : path}`;
  // Merge page-specific keywords first (weighted higher by search engines when repeated in title/desc)
  const kw = [...new Set([...(keywords || []), ...GLOBAL_KEYWORDS])].join(", ");

  const breadcrumbSchema = breadcrumbs
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${DOMAIN}${b.path}`,
        })),
      }
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Paradise Beach Rental" />
      <meta property="og:locale" content="en_US" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />
      {/* Geo */}
      <meta name="geo.region" content="US-FL" />
      <meta name="geo.placename" content="Indialantic" />
      <meta name="geo.position" content="28.0883;-80.5667" />
      <meta name="ICBM" content="28.0883, -80.5667" />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
